import React, { useState, useEffect } from "react";
import { getTeamMembers } from "../firestoreServices";

const Team = ({ lang }) => {
  const [dbMembers, setDbMembers] = useState([]);
  const avatarImg = "https://cdn-icons-png.flaticon.com/512/1077/1077114.png";

  const staticContent = {
    ar: {
      subTitle: "نخبة من الخبراء",
      title: "الشركاء والمستشارون",
      footer: "يضم مكتبنا نخبة من أفضل الكفاءات القانونية التي تجمع بين الخبرة الأكاديمية والممارسة العملية الطويلة.",
    },
    en: {
      subTitle: "Our Experts",
      title: "Meet The Team",
      footer: "Our office includes a select group of top legal professionals who combine academic expertise with extensive practical experience.",
    },
  };
  const t = staticContent[lang];

  useEffect(() => {
    getTeamMembers().then((data) => {
      if (data.length > 0) setDbMembers(data);
    });
  }, []);

  // تحويل البيانات
  const members =
    dbMembers.length > 0
      ? dbMembers.map((m) => ({
          id: m.id,
          img: m.img || avatarImg,
          name: m[lang]?.name || m.en?.name,
          role: m[lang]?.role || m.en?.role,
          bio: m[lang]?.bio || m.en?.bio,
        }))
      : []; // هنا حط الـ default content القديم لو حابب

  const isAr = lang === "ar";

  return (
    <section className="team-section" id="team" dir={isAr ? "rtl" : "ltr"}>
      <div className="container">
        <div className="section-header center">
          <h4 className="sub-heading">{t.subTitle}</h4>
          <h2 className="main-heading">{t.title}</h2>
          <div className="heading-line"></div>
        </div>

        <div className="team-grid">
          {members.map((member) => (
            <div className="team-card" key={member.id}>
              <div className="member-img-wrapper avatar-wrapper">
                <img
                  src={member.img}
                  alt={member.name}
                  className="member-img avatar-img"
                />
              </div>
              <div className="member-info">
                <h3 className="member-name">{member.name}</h3>
                <span className="member-role">{member.role}</span>
                {member.bio && <div className="divider-small"></div>}
                <p className="member-bio">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Note بنفس الستايل القديم */}
        <div
          className="team-footer-note"
          style={{
            textAlign: "center",
            marginTop: "40px",
            padding: "20px",
            background: "#111111",
            borderRadius: "8px",
            border: "1px solid #C5A059",
          }}
        >
          <h3
            style={{
              color: "#C5A059",
              fontSize: "1.2rem",
              fontWeight: "bold",
              margin: 0,
            }}
          >
            {t.footer}
          </h3>
        </div>
      </div>
    </section>
  );
};

export default Team;
